import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  function sectionHref(hash) {
    return isHome ? hash : `/${hash}`;
  }

  return (
    <header className="header">
      <div className="header-inner">
        <Link to="/" className="logo">
          <span className="logo-icon">☕</span>
          <span className="logo-text">CoffeeIL</span>
        </Link>
        <nav className="nav">
          <a href={sectionHref('#products')}>המוצרים</a>
          <a href={sectionHref('#story')}>הסיפור שלנו</a>
          <a href={sectionHref('#blog')}>הבלוג</a>
          <a href={sectionHref('#contact')}>צרו קשר</a>
        </nav>
      </div>
    </header>
  );
}
